import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function filetoBase64(file): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const splitted = (<string>reader.result).split(",");
        resolve(splitted[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  }
  return {
    filetoBase64,
  };
}
